import { Hauler, Profile } from '@alliance-disposal/transport-types';
import userflow from 'userflow.js';

let isInitialized = false;

const getUserflowToken = () => import.meta.env.VITE_USERFLOW_TOKEN?.trim();

const initializeUserflow = () => {
    const token = getUserflowToken();
    if (!token) return false;

    if (!isInitialized) {
        userflow.init(token);
        isInitialized = true;
    }

    return true;
};

const reportUserflowError = (error: unknown) => {
    console.error('Userflow error:', error);
};

export const initUserflow = () => {
    try {
        initializeUserflow();
    } catch (error) {
        reportUserflowError(error);
    }
};

export const identifyUserflowUser = (user: Profile.ProfileTransport, hauler: Hauler.HaulerTransport) => {
    const nameFromParts = [user.firstName, user.lastName].filter(Boolean).join(' ');
    const name = user.fullName || nameFromParts || user.email || user.phoneNumber;

    try {
        if (!initializeUserflow()) return;

        void userflow
            .identify(user.id, {
                name,
                email: user.email ?? undefined,
                signed_up_at: user.metadata.createdAt,
                hauler_id: hauler.id,
                hauler_name: hauler.name,
                partner_portal: hauler.waysteLite,
            })
            .catch(reportUserflowError);
    } catch (error) {
        reportUserflowError(error);
    }
};

export const resetUserflow = () => {
    if (!isInitialized) return;

    try {
        userflow.reset();
    } catch (error) {
        reportUserflowError(error);
    }
};
